
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpWrapperService } from '../../services/http-wrapper.service';
import { environment } from '../../../environments/environment';
import { apiConstant } from '../../../app/app-constant';
import { UserService } from '../../services/user.service';
import { nodeTypes, authCookieName } from '../../../app/app-constant';
import { appRoutes } from '../../../app/routes.constant';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';

@Injectable()
export class LoginService {

  _loggedIn: string;
  _token: string;

  constructor(private httpWrapperService: HttpWrapperService, private userService: UserService, private router: Router) { }

  get loggedIn() {
    /* if(!this._loggedIn) {
      this._loggedIn = localStorage.getItem('loggedIn') ? 'Y' : null;
    } */
    this._loggedIn = localStorage.getItem('loggedIn') ? 'Y' : null;
	  return this._loggedIn;
  }

  set loggedIn(val: string) {
    localStorage.setItem("loggedIn", val);
    this._loggedIn = val;
  }

  get token() {
    if(!this._token) {
      this._token = localStorage.getItem("token");
    }
    return this._token;
  }

  set token(val: string) {
    this._token = val;
    localStorage.setItem("token", val);
  }

  login(logindata): Observable<any> {
    const that = this;
    return this.httpWrapperService.post(this.userService.apiHost + apiConstant.LOGIN, logindata)
                .map(function(res: any) {
                  //localStorage.setItem("loggedIn", 'Y');
                  //that._loggedIn = 'Y';
                  that.userService.userName = logindata.username;
                  that.userService.displayName = logindata.displayName ? logindata.displayName : logindata.username;
                  that.userService.lastLogin = logindata.lastLogin ? logindata.lastLogin : 'NA';

                  localStorage.setItem("token", res.token);
                  that._token = res.token;

                  let tokenInfo = that.getDecodedAccessToken(res.token); // decode token
                  
                  //that.userService.nodeName = tokenInfo.sub;
                  that.userService.nodeType = tokenInfo.role;
                  that.userService.userDataSub.next('Y');

                  if(tokenInfo.role == nodeTypes.ADMIN) {
                    localStorage.setItem("loggedIn", 'Y');
                    that._loggedIn = 'Y';
                  }

                  //return res || {};
                  return tokenInfo;
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }

  loginAuth(logindata): Observable<any> {
    let that = this;
    return this.httpWrapperService.post(this.userService.apiHost + apiConstant.LOGIN_SAML, logindata)
                .map(function(res: any) {
                  //localStorage.setItem("loggedIn", 'Y');
                  //that._loggedIn = 'Y';
                  that.userService.userName = logindata.username;
                  that.userService.displayName = logindata.displayName ? logindata.displayName : logindata.username;
                  that.userService.lastLogin = logindata.lastLogin ? logindata.lastLogin : 'NA';

                  localStorage.setItem("token", res.token);
                  that._token = res.token;

                  let tokenInfo = that.getDecodedAccessToken(res.token); // decode token
                  
                  //that.userService.nodeName = tokenInfo.sub;
                  that.userService.nodeType = tokenInfo.role;
                  that.userService.userDataSub.next('Y');

                  if(tokenInfo.role == nodeTypes.ADMIN) {
                    localStorage.setItem("loggedIn", 'Y');
                    that._loggedIn = 'Y';
                  }

                  //return res || {};
                  return tokenInfo;
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }

  jwtAuth() {    
    localStorage.setItem("token", this.userService.getCookie('jwt_token'));
    this._token = this.userService.getCookie('jwt_token');

    //let tokenInfo = this.getDecodedAccessToken(jwtToken); // decode token
    //this.userService.userName = tokenInfo.sub;
    //this.userService.displayName = tokenInfo.displayName ? tokenInfo.displayName : tokenInfo.sub;
    //that.userService.lastLogin = logindata.lastLogin ? logindata.lastLogin : 'NA';
    this.userService.userName = this.userService.getCookie('username');
    this.userService.displayName = this.userService.getCookie('username');
    
    //that.userService.nodeName = tokenInfo.sub;
    this.userService.nodeType = nodeTypes.CUSTOMER;
    this.userService.userDataSub.next('Y');

    /* if(loginData.role == nodeTypes.ADMIN) {
      localStorage.setItem("loggedIn", 'Y');
      this._loggedIn = 'Y';
    } */

    //return tokenInfo;
  }

  getUserData(securityService = false, toggelHeader = true): Observable<any> {
    let that = this;
    return this.httpWrapperService.get(this.userService.apiHost + apiConstant.ME, {}, false, toggelHeader)
                .map(function(res: any) {
                  let data = res || {};
                  //that.userService.nodeName = data.me.organisation;
                  //that.userService.nodeType = data.me.organisationUnit;
                  //that.userService.userDataSub.next('Y');

                  that.userService.nodeName = data.me.organisation;
                  that.userService.userDataSub.next('Y');
                  if(!securityService) {
                    localStorage.setItem("loggedIn", 'Y');
                    that._loggedIn = 'Y';
                  }
                  return data;
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }

  logout(): Observable<any> {
    let that = this;
     return this.httpWrapperService.get(this.userService.apiHost + apiConstant.LOGOUT, {})
                .map(function(res: any) {
                  //window.location.href = this.userService.hsbcNetUrl;
                  that.logoutUnsetData();
                  return res || {};
                })
                .catch(function(err) {
                  //window.location.href = this.userService.hsbcNetUrl;
                  that.logoutUnsetData();
                  return observableThrowError(err.message || err);
                });
  }

  logoutUnsetData() {
    //localStorage.removeItem("loggedIn");
    this._loggedIn = null;
    //localStorage.removeItem("token");
    this._token = null;
    //window.location.href = this.userService.hsbcNetUrl;
    //localStorage.removeItem('stopFirstLoader');
    this.userService.deleteCookie(authCookieName);
    this.userService.deleteCookie('username');
    localStorage.clear();
    //return Observable.of({});
  }

  getLandingRoute() {
    let landingRoute;
    if(this.userService.nodeType == nodeTypes.CUSTOMER) {
      landingRoute = appRoutes.HOLD_TRANSACTIONS_HOLDINGS;
    } else if(this.userService.nodeType == nodeTypes.ADMIN) {
      landingRoute = appRoutes.USERS;
    }

    return landingRoute;
  }

  getDecodedAccessToken(token: string): any {
    try{
        return jwt_decode(token);
    }
    catch(Error){
        return null;
    }
  }

}
